<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Articles',
}
</script>

<script setup>
import {Swipe, SwipeItem} from 'vant'
import ArticleItem from './article-item.vue'
import '@vant/touch-emulator'

defineProps({
  items: {
    type: Array,
    required: true,
  },
})

</script>

<template>
  <div class="articles">
    <template v-if="items && items.length">
      <swipe
        :autoplay="3500"
        :show-indicators="true"
        :loop="true"
        :lazy-render="false"
        :touchable="true"
        :indicator-color="'#ffffff'">
        <template
          v-for="(item) in items"
          :key="item.id">
          <swipe-item>
            <article-item :item="item" />
          </swipe-item>
        </template>
      </swipe>
    </template>
  </div>
</template>

<style lang="scss" scoped>
:deep(.swiper-pagination-bullet-active) {
  background-color: #ffffff;
}
</style>
